// =============================================================================
// state
// =============================================================================
const state = {
  items: [],
  items_id_list: [],
  roasteds: [],
};
// =============================================================================
// getters
// =============================================================================
const getters = {
  items: state => state.items,
  items_id_list: state => state.items_id_list,
  roasteds: state => state.roasteds,
};
// =============================================================================
// actions
// =============================================================================
const actions = {
};
// =============================================================================
// mutations
// =============================================================================
const mutations = {
  set_data (state, value) {
    state.items = value.items;
    state.roasteds = value.roasteds;
    const num = value.items.length;
    const id_list = [];
    for (let i = 0; i < num; i++) {
      id_list[value.items[i].id] = value.items[i];
    }
    state.items_id_list = id_list;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
